<template>
  <h4 v-if="areaname">{{ areaname }} </h4>
</template>

<script>
  export default {
    name: 'FBimage',
    data () {
      return {
      }
    },
    props: {
      areaid: {
        // type: Array
      },
      areaname: {
        // type: Array
      }      
    },    
    methods:{
      /*
      getTitle (id) {
        return this.titleArray.find((i) => i.id === id);
      }
      */
    },
    mounted() {
        //console.log("Mounted contacts module");
        //console.log(this.contacts);            
    } 
  }
</script>

<style>

</style>
